import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { matchValueRule, minLengthRule, requiredRule } from '@utils/rules'
import { Form, Input } from 'antd'

const Create = ({ form }: SBRMFormActionProps) => {
  const password = Form.useWatch('password', form)
  return (
    <Form form={form} layout="vertical">
      <Form.Item
        name="username"
        rules={[requiredRule(), minLengthRule(6)]}
        label={'Username'}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[requiredRule(), minLengthRule(6)]}
        label={'Password'}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item
        name="confirmPassword"
        rules={[requiredRule(), matchValueRule(password), minLengthRule(6)]}
        label={'Confirm password'}
      >
        <Input.Password />
      </Form.Item>
      <Form.Item name="venue" rules={[requiredRule()]} label={'Venue'}>
        <SBAsyncSelect
          entity={Entity.venue}
          allowClear
          initialQuery={{
            ...initialQuery,
            pagination: {
              ...initialQuery.pagination,
              pageSize: 100,
              current: 1,
            },
            filters: {
              venuesBusiness: [true],
            },
          }}
        />
      </Form.Item>
    </Form>
  )
}

export default Create
